import React from 'react'

import FOCUSED_VIEW_IMAGE from '@public/assets/welcome-wizard/best-practices-focus.png'
import MORE_MENU_IMAGE from '@public/assets/welcome-wizard/best-practices-more.png'

const BestPracticesStep = () => {
  return (
    <div className="flex max-w-[900px] flex-col gap-5">
      <section className="flex items-center gap-5">
        <div className="min-w-0 flex-1">
          <h2 className="text-lg font-semibold leading-[30px] text-black">
            Focused View
          </h2>
          <p className="mt-3 text-base leading-[1.35] tracking-[0.5px] text-[#666]">
            By default, MIRA shows only focused activities in timeline panel.
            Personal and non-billable activities are hidden. Switch to{' '}
            <strong className="font-semibold">All</strong> to view all
            activities and restore them as billable when appropriate.
          </p>
        </div>
        <div className="w-40 shrink-0">
          <img
            alt="Focused and All timeline view options"
            className="h-8 w-40 object-contain"
            src={FOCUSED_VIEW_IMAGE}
          />
        </div>
      </section>

      <section className="flex items-start gap-5">
        <div className="min-w-0 flex-1">
          <h2 className="text-lg font-semibold leading-[30px] text-black">
            Block Email Senders
          </h2>
          <p className="mt-3 text-base leading-[1.35] tracking-[0.5px] text-[#666]">
            You can exclude specific senders from activity tracking, such as
            marketing emails, newsletters, or personal emails that should not be
            recorded as billable work. To block a sender, open the email
            activity, click the{' '}
            <strong className="font-semibold">More ( ⋮ )</strong> menu, and
            select <strong className="font-semibold">Block</strong>.
          </p>
        </div>
        <div className="w-40 shrink-0">
          <img
            alt="Timeline activity More menu with Block action"
            className="h-[114px] w-40 object-contain"
            src={MORE_MENU_IMAGE}
          />
        </div>
      </section>
    </div>
  )
}

export default BestPracticesStep
